import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ConfigService } from '../../services/config/config.service';
import { DataService } from '../../services/data/data.service';
import { DataModalComponent } from '../data-modal/data-modal.component';


@Component({
	selector: 'pcm-data-modal-pocontractor',
	templateUrl: './data-modal-pocontractor.component.html',
	styleUrls: [
		'../data-modal/data-modal.component.scss',
		'./data-modal-pocontractor.component.scss'
	]
})

// DEPRECATED: This component can PROBABLY be removed. Research to confirm.
// It was used for confirming adding multiple contractors to a PO, which is no longer supported.
export class DataModalPocontractorComponent extends DataModalComponent {

	@Output() formEdit: EventEmitter<any> = new EventEmitter();
	@Output() formNew: EventEmitter<any> = new EventEmitter();

	title = 'Verify Contractor Record Creation';
	contractorTableTitle = 'Available Contractor Records';

	tableEvent;

	constructor(
		public dataService: DataService,
		public configService: ConfigService
	) {
		super(configService);
	}

	tableClick(event) {
		console.log('DATA MODAL PO CONT TABLE CLICK: ', event);
		this.tableEvent = event;
	}

	pageFormEdit(event) {

		this.formEdit.emit({
			event: event,
			data: this.modalData,
			tableEvent: this.tableEvent
		});

	}

	pageFormNew(event) {

		this.formNew.emit({
			event: event,
			data: this.modalData
		});

	}

}
